import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'

export default function DragHolder({ element, connectDragSource }) {
    const pill = (
        <div className='dndEditorv2-ui-dd-drag-bar-content'>
            <Icons icon='drag' color='white' style={{ width: '18px', height: '18px' }} alt='Move' title='Move' />
            <span>{element.name}</span>
        </div>
    )
    return connectDragSource ? connectDragSource(pill) : pill
}
